














































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { namespace } from 'vuex-class';
import { KCardHeaderBtn, KCardHeader, KCardFooter, KCardFooterBtn } from '@kasasa/fbase-components';
import { SiteService, Site } from '@/services/SiteService';
import { AuthGroupManager } from '@kasasa/fbase-components/lib';
import orderby from 'lodash/orderBy';

const auth = namespace('auth');

@Component({
	components: {
		KCardHeader,
		KCardHeaderBtn,
		KCardFooter,
		KCardFooterBtn
	},
	computed: {
		...mapState(['auth'])
	}
})
export default class SitesPage extends Vue {
	@auth.State('authManager') authManager!: AuthGroupManager;
	canWrite = false;
	siteId = '';

	siteSvc: SiteService = new SiteService(this.$store);
	sites: Site[] = [];

	get setupMessage() {
		if (this.$route.meta.mode && this.$route.meta.mode == 'edit') {
			/* eslint max-len: ["error", { "ignoreStrings": true }] */
			return 'Select a site to view available locations. Available locations can then be moved or dragged onto the live locations card. You can also drag live locations into the order you want them to appear on your site.';
		} else {
			return 'Select a site to view locations.'
		}
	}

	created() {
		// to be used w/ k-card-header for the action buttons
		this.canWrite = this.authManager.canWrite('branches');
	}

	get displayEditBtn() {
		return this.canWrite && this.$route.meta.mode && this.$route.meta.mode == 'view'
	}

	navToSite() {
		this.$router.push({ name: 'SiteMap', params: { clientId: this.$route.params.clientId, id: this.siteId }});
	}

	navToEdit() {
		this.$router.push({name: 'SiteMapEdit', params: { clientId: this.$route.params.clientId, id: this.siteId }});
	}

	get title() {
		return this.$route.meta.title;
	}

	closeAction() {
		this.$router.push({name: 'Locations', params: this.$route.params});
	}

	@Watch('$route', { immediate: true, deep: true })
	loadData() {
		if (this.$route.params.id) {
			this.siteId = this.$route.params.id;
		}
		this.siteSvc.findAll(this.$route.params.clientId)
			.then(resp => {
				this.sites = orderby(resp.data.data, ['isDefaultSite', site => site.name.toLowerCase()], ['desc', 'asc']);
			})
			.catch(() => {
				// no errors besides 401, 403 and 500 to listen for.
			});
	}

	get items(): Array<object> {   
		const items = [];
		items.push(
        {
          key: '0',
          text: 'Locations',
          disabled: false,
          link: true,
          exact: true,
          to: { name: 'Locations', params: { clientId: this.$route.params.clientId } },
				});
		switch (this.$route.name) {
			case 'SiteMapEdit':
				items.push({
						key: '1',
						text: 'Site Setup',
						exact: true,
						link: true,
						disabled: false,
						to: { name: 'SiteMap', params: { clientId: this.$route.params.clientId, id: this.$route.params.id } },
					});
				items.push({
						key: '2',
						text: this.title,
						disabled: true,
					});
				break;
			default:
				
				items.push({
						key: '1',
						text: this.title,
						disabled: true,
					});
				break;
		}
		
		return items;
	}

	defaultDomain(site: Site): string {
		const defaultDomain = site.domains.find(
			(domain) => domain.isDefault == true
		);
		return defaultDomain ? defaultDomain.domain : '[not set]';
	}
}
